import { __assign } from "tslib";
import React, { useRef, useEffect } from "react";
import "viewerjs/dist/viewer.css";
import { makeStyles, createStyles } from "@material-ui/core";
import Viewer from "viewerjs";
var useStyles = makeStyles(function () {
  return createStyles({
    container: {
      position: "relative",
      top: "0",
      left: "0"
    },
    image: {
      width: 56,
      height: 80,
      verticalAlign: "middle",
      objectFit: "cover"
    }
  });
});

var ImageViewer = function ImageViewer(_a) {
  var url = _a.url,
      style = _a.style,
      imgAttrs = _a.imgAttrs;
  var classes = useStyles();
  var imageDom = useRef(null);
  var viewerObj = useRef(null);

  var zoomIn = function zoomIn() {
    var _a;

    (_a = viewerObj.current) === null || _a === void 0 ? void 0 : _a.show();
  };

  useEffect(function () {
    viewerObj.current = new Viewer(imageDom.current, {
      toolbar: false,
      navbar: false,
      title: false
    });
    return function () {
      var _a;

      (_a = viewerObj.current) === null || _a === void 0 ? void 0 : _a.destroy();
      viewerObj.current = null;
    };
  }, []);
  return React.createElement("div", {
    className: classes.container
  }, React.createElement("img", __assign({
    src: url,
    className: classes.image,
    ref: imageDom,
    alt: "",
    onClick: zoomIn,
    style: style
  }, imgAttrs)));
};

export default ImageViewer;